export default __webpack_public_path__ + "static/shyam-b29e2ae64e7e2d57252145432f19bb6b.jpg";